import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03e09a0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card-header border-0 pt-5 pb-3",
  style: {"border-radius":"0.75rem 0.75rem 0 0","border-bottom":"1px solid #eff2f5 !important"}
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "fw-bolder fs-3 mb-1 text-primary px-3 py-1 rounded" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  key: 0,
  class: "text-muted fs-6 me-4"
}
const _hoisted_7 = { class: "dropdown" }
const _hoisted_8 = {
  class: "btn btn-sm btn-color-muted btn-active btn-active-light-primary dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_11 = { class: "card-body pt-4 pb-4" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-header" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-line" }, null, -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "row"
}
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label rounded-circle bg-light-purple" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-gavel fs-3 text-purple" })
  ])
], -1))
const _hoisted_20 = { class: "flex-grow-1" }
const _hoisted_21 = { class: "text-muted fs-7 fw-semibold mb-1" }
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = { class: "fs-2 fw-boldest text-dark me-2" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "col-6" }
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-50px me-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label rounded-circle bg-light-orange" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt fs-3 text-orange" })
  ])
], -1))
const _hoisted_28 = { class: "flex-grow-1" }
const _hoisted_29 = { class: "text-muted fs-7 fw-semibold mb-1" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = { class: "fs-2 fw-boldest text-dark me-2" }
const _hoisted_32 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDatePicker = _resolveComponent("CustomDatePicker")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.translate('auctionsSummary')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.selectedPeriod === 'custom')
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(`${_ctx.customDateFrom} till ${_ctx.customDateTo}`), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.selectedPeriod), 1),
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'yesterday' }]),
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectPeriod('yesterday')), ["prevent"]))
                }, _toDisplayString(_ctx.translate('yesterday')), 3)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'last-7-days' }]),
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-7-days')), ["prevent"]))
                }, _toDisplayString(_ctx.translate('last7Days')), 3)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'last-30-days' }]),
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectPeriod('last-30-days')), ["prevent"]))
                }, _toDisplayString(_ctx.translate('last30Days')), 3)
              ]),
              _hoisted_10,
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: _normalizeClass(["dropdown-item", { active: _ctx.selectedPeriod === 'custom' }]),
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showCustomDatePicker()), ["prevent"]))
                }, _toDisplayString(_ctx.translate('customRange')), 3)
              ])
            ])
          ]),
          _createVNode(_component_CustomDatePicker, {
            show: _ctx.showDatePicker,
            dateFrom: _ctx.customDateFrom,
            "onUpdate:dateFrom": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customDateFrom) = $event)),
            dateTo: _ctx.customDateTo,
            "onUpdate:dateTo": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customDateTo) = $event)),
            onApply: _ctx.applyCustomDates,
            onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDatePicker = false))
          }, null, 8, ["show", "dateFrom", "dateTo", "onApply"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.translate('totalAdminAuctions')), 1),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString((_ctx.adminAuctions.total ?? 0).toLocaleString()), 1),
                    (_ctx.adminAuctions.percentage !== 0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "fs-7 fw-bold d-flex align-items-center",
                          style: _normalizeStyle({ color: _ctx.getTextColor(_ctx.adminAuctions.percentage) })
                        }, [
                          _createTextVNode(_toDisplayString(Math.abs(_ctx.adminAuctions.percentage ?? 0)) + "% ", 1),
                          _createElementVNode("img", {
                            class: "w-15px h-15px ms-1",
                            src: _ctx.getArrowSrc(_ctx.adminAuctions.percentage)
                          }, null, 8, _hoisted_24)
                        ], 4))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.translate('totalScheduledAuctions')), 1),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, _toDisplayString((_ctx.scheduledAuctions.total ?? 0).toLocaleString()), 1),
                    (_ctx.scheduledAuctions.percentage !== 0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "fs-7 fw-bold d-flex align-items-center",
                          style: _normalizeStyle({ color: _ctx.getTextColor(_ctx.scheduledAuctions.percentage) })
                        }, [
                          _createTextVNode(_toDisplayString(Math.abs(_ctx.scheduledAuctions.percentage ?? 0)) + "% ", 1),
                          _createElementVNode("img", {
                            class: "w-15px h-15px ms-1",
                            src: _ctx.getArrowSrc(_ctx.scheduledAuctions.percentage)
                          }, null, 8, _hoisted_32)
                        ], 4))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}